import {
  FETCH_COMMITS,
  FETCH_COMMITS_SUCCESS,
  FETCH_COMMITS_ERROR,
} from '../actions';

export const fetchCommits = (branch) => ({
  type: FETCH_COMMITS,
  payload: {
    branch,
  },
});

export const fetchCommitsSuccess = (data) => ({
  type: FETCH_COMMITS_SUCCESS,
  payload: {
    data,
  },
});

export const fetchCommitsError = (error) => ({
  type: FETCH_COMMITS_ERROR,
  payload: {
    error,
  },
});
